module.exports = __webpack_public_path__ + "static/media/Screenshot_1.9ab19d6f.png";